"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResetPasswordApiClient = createResetPasswordApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createResetPasswordApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function requestPasswordReset(request) {
        try {
            await client.post('/v1/reset-password', request);
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        requestPasswordReset
    };
}
